import { Component, HostBinding, OnInit } from '@angular/core';
import { MuiLegacyButton, MuiLegacyButtonAppearance } from '../button-legacy/mui-legacy-button.component';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'button[mui-legacy-icon-btn], a[mui-legacy-icon-btn]',
  template: `
    <i mui-icon font="fa" class="mui-icon-btn__icon" *ngIf="icon" [name]="working ? 'spinner-third' : icon" [spinning]="working"></i>
  `
})
export class MuiLegacyIconButton extends MuiLegacyButton implements OnInit {
  @HostBinding('class.mui-legacy-icon-btn') _iconButtonBaseClass = true;

  ngOnInit() {
    if (!this.appearance) {
      this.appearance = MuiLegacyButtonAppearance.GHOST;
    }
  }
}
